module.exports = __webpack_public_path__ + "static/media/speech_21.01eb07ad.svg";